import loadLocaleMessages from "@/plugins/i18n/localeImporter";

export default loadLocaleMessages(
  require.context(`@/locales/nl-NL`, false, /\.json$/)
);
